// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"a03271cf","211":"853070b9"}[chunkId] + ".chunk.css";
};